import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    document.title = 'Método Express: 7 Arreglos que Pagan la Renta';
  }, []);
  return <SalesPage data-id="element-0" />;
}